import { render, staticRenderFns } from "./VToggle.vue?vue&type=template&id=4643f9d6&scoped=true&functional=true"
import script from "./VToggle.vue?vue&type=script&lang=js"
export * from "./VToggle.vue?vue&type=script&lang=js"
import style0 from "./VToggle.vue?vue&type=style&index=0&id=4643f9d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "4643f9d6",
  null
  
)

export default component.exports